import './BetbookChart.less';
import React from 'react';
import clsx from 'clsx';
import ArrowPointRightIcon from '../../icons/svg/arrow-point-right-icon-sv.svg';
import i18n from '../../common/i18n';

function BetbookChart({ stakeShare, otherClassName = '', onClick, overview = false }) {
    const otherShare =
        stakeShare && stakeShare !== 0 ? (100 * 100 - stakeShare * 100) / 100 : stakeShare && stakeShare === 100 && 0;

    return (
        <div className="chart-fade-in flex-col pointer betbook-chart-wrapper mt-10" onClick={onClick}>
            <div className={clsx('flex justify-between items-center full-width', otherClassName)}>
                <div className="betbook-chart-stakeShare-bar" style={{ width: `${stakeShare}%` }} />
                {otherShare !== 0 && (
                    <div
                        className={clsx('betbook-chart-otherShare-bar', { 'ml-3': stakeShare !== 0 })}
                        style={{ width: `${otherShare}%` }}
                    />
                )}
            </div>
            {stakeShare >= otherShare && (
                <div className={clsx('betbook-chart-stakeShare-lbl text-left mt-5 fs-14', otherClassName)}>
                    {i18n('nui.betbook.chart.stakeShare.lbl', stakeShare)}
                    <ArrowPointRightIcon />
                </div>
            )}
            {otherShare > stakeShare && (
                <div className={clsx('betbook-chart-otherShare-lbl text-right mt-5 fs-14', otherClassName)}>
                    {i18n('nui.betbook.chart.otherShare.lbl', otherShare)}
                    <ArrowPointRightIcon />
                </div>
            )}
        </div>
    );
}

export default BetbookChart;
